import Modal from "./Modal";

export { Modal };
export { AdmissionResponseSuccessDialog } from "@/components/Modal/AdmissionResponseSuccessDialog";
